<template>
  <layout-page>
    <tabs-vertical :tab-index="currentTab">
      <b-tab-item
        label="Account"
        value="account"
        icon="chart-line"
        v-if="isOwner"
      >
        <template v-if="currentTab === 'account'">
          <stats-account-tab v-if="hasAdvancedReportingFeature"/>
          <stats-upgrade-tab v-else/>
        </template>
      </b-tab-item>

      <b-tab-item
        label="Team"
        value="team"
        icon="contacts"
      >
        <template v-if="currentTab === 'team'">
          <stats-team-tab v-if="hasAdvancedReportingFeature"/>
          <stats-upgrade-tab v-else/>
        </template>
      </b-tab-item>

      <b-tab-item
        label="Leads and Deals"
        value="deals"
        icon="currency-usd"
      >
        <template v-if="currentTab === 'deals'">
          <stats-deals-tab v-if="hasAdvancedReportingFeature"/>
          <stats-upgrade-tab v-else/>
        </template>
      </b-tab-item>

      <b-tab-item
        label="Campaigns"
        value="campaigns"
        icon="bullhorn-outline"
      >
        <stats-campaigns-tab v-if="currentTab === 'campaigns'"/>
      </b-tab-item>

      <b-tab-item
        label="KPIs"
        value="kpis"
        icon="chart-box-outline"
      >
        <stats-kpi-tab v-if="currentTab === 'kpis'"/>
      </b-tab-item>

      <b-tab-item
        v-if="canAccessFinancialStats"
        label="Funnel"
        value="funnel"
        icon="filter"
      >
        <template v-if="currentTab === 'funnel'">
          <stats-funnel-tab v-if="hasAdvancedReportingFeature"/>
          <stats-upgrade-tab v-else/>
        </template>
      </b-tab-item>

      <b-tab-item
        v-if="$store.getters.mailgunIsIntegrated"
        label="Emails"
        value="email"
        icon="email"
      >
        <template v-if="currentTab === 'email'">
          <stats-email-tab v-if="hasAdvancedReportingFeature"/>
          <stats-upgrade-tab v-else/>
        </template>
      </b-tab-item>
    </tabs-vertical>
  </layout-page>
</template>

<script>
import StatsKpiTab from "./StatsKpiTab";
import StatsFunnelTab from "./StatsFunnelTab";
import StatsDealsTab from "./StatsDealsTab";
import StatsEmailTab from "./StatsEmailTab";
import StatsAccountTab from "./StatsAccountTab";
import StatsUpgradeTab from "./StatsUpgradeTab";
import StatsCampaignsTab from "./StatsCampaignsTab.vue";
import StatsTeamTab from "./StatsTeamTab.vue";

export default {
  name: "StatsPage",
  metaInfo() {
    return {
      title: this.metaTitle,
    };
  },
  components: {
    StatsTeamTab,
    StatsCampaignsTab,
    StatsUpgradeTab,
    StatsEmailTab,
    StatsDealsTab,
    StatsKpiTab,
    StatsFunnelTab,
    StatsAccountTab,
  },
  data() {
    return {
      currentTab: this.hasAdvancedReportingFeature ? "account" : "kpis"
    };
  },
  computed: {
    hasAdvancedReportingFeature() {
      return this.$store.getters.account.has_advanced_reporting_feature;
    },
    authUser() {
      return this.$store.getters.authUser;
    },
    isOwner() {
      return this.authUser.is_owner;
    },
    canAccessFinancialStats() {
      if (this.isOwner) {
        return true;
      }

      return this.authUser.can_access_financial_stats;
    },
    metaTitle() {
      switch (this.currentTab) {
        case "kpis":
          return "KPI Stats";
        case "deals":
          return "Leads and Deals Stats";
        case "campaigns":
          return "Campaign Stats";
        case "funnel":
          return "Funnel Stats";
        case "email":
          return "Email Stats";
        case "account":
          return "Account Stats";
        case "team":
          return "Team Stats";
        default:
          return "Stats";
      }
    }
  },
  watch: {
    $route() {
      this.setTab();
    },
    currentTabs: function (newTab) {
      if (newTab !== this.$route.params.tab) {
        this.$router.replace({params: {tab: this.currentTab}});
      }
    }
  },
  created() {
    this.setTab();
  },
  methods: {
    setTab() {
      if (this.$route.params.tab) {
        this.currentTab = this.$route.params.tab;
      } else {
        this.$router.replace({params: {tab: this.currentTab}});
      }
    }
  }
};
</script>
